import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import axios from 'axios';
import { NavLink } from "react-router-dom";

import "../assets/css/datatables-bs4/css/dataTables.bootstrap4.min.css";
import "../assets/css/datatables-responsive/css/responsive.bootstrap4.min.css";

function Rol() {
//  const baseUrl = "http://localhost/api-legalallies/rol.php";
//  const baseUrl = "https://api.legalallies.es/";
  const baseUrl = "https://api.legalallies.es/rol.php";
  
  const [data, setData] = useState([]);
  const [modalInsertar, setModalInsertar] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [rolSeleccionado, setRolSeleccionado] = useState({
    id: '',
    nombre: ''
  });
  const [errorEnviar, setErrorEnviar] = useState(null);
  const [espera, setEspera] = useState(true);

  const handleChange = e => {
    const { name, value } = e.target;
    setRolSeleccionado((prevState) => ({
      ...prevState,
      [name]: value
    }))
    if(rolSeleccionado.rol && rolSeleccionado.nombre){
      setEspera(false);
      setErrorEnviar(false);
    }
    console.log(rolSeleccionado.rol);
  };

  const abrirCerrarModalInsertar = () => {
    setModalInsertar(!modalInsertar);
  };

  const abrirCerrarModalEditar = () => {
    setModalEditar(!modalEditar);
  };

  const abrirCerrarModalEliminar = () => {
    setModalEliminar(!modalEliminar);
  };

  const peticionGet = async () => {
    await axios.get(baseUrl).then(response => {
      setData(response.data);
    }).catch(error => {
      console.log(error);
    })
  };

  const peticionPost = async () => {
    var f = new FormData();
    f.append("nombre", rolSeleccionado.nombre);
    f.append("METHOD", "POST");
    await axios.post(baseUrl, f).then(response => {
      setData(data.concat(response.data));
      abrirCerrarModalInsertar();
    }).catch(error => {
      console.log(error);
    })
  };

  const peticionPut = async () => {
    var f = new FormData();
    f.append("nombre", rolSeleccionado.nombre);
    f.append("METHOD", "PUT");
    await axios.post(baseUrl, f, { params: { id: rolSeleccionado.id } }).then(response => {
      var dataNueva = data;
      dataNueva.map(rol => {
        if (rol.id === rolSeleccionado.id) {
          rol.nombre = rolSeleccionado.nombre;
        }
      });
      setData(dataNueva);
      abrirCerrarModalEditar();
    }).catch(error => {
      console.log(error);
    })
  };

  const peticionDelete = async () => {
    var f = new FormData();
    f.append("METHOD", "DELETE");
    await axios.post(baseUrl, f, { params: { id: rolSeleccionado.id } }).then(response => {
      setData(data.filter(rol => rol.id !== rolSeleccionado.id));
      abrirCerrarModalEliminar();
    }).catch(error => {
      console.log(error);
    })
  };

  const seleccionarRol = (rol, caso) => {
    setRolSeleccionado(rol);

    (caso === "Editar") ?
      abrirCerrarModalEditar() :
      abrirCerrarModalEliminar()
  };

  useEffect(() => {
    peticionGet();
  }, [])
  return (
    <div style={{ textAlign: 'center' }}>

      <br />
      <div  style={{ textAlign: 'center' }}>
        <button className='btn btn-success' onClick={() => abrirCerrarModalInsertar()}>Insertar</button>
      </div>

      <div  style={{ textAlign: 'right' }}>
        <NavLink to="/configuracion">
          <a data-widget="pushmenu" href="#" role="button"><i class="fas fa-cog"></i></a>
        </NavLink>
      </div>
      <table className='table table-bordered table-hover table-striped table-responsive'>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {data.map(rol => (
            <tr key={rol.id}>
              <td>{rol.nombre}</td>
              <td>
                <a className="nav-link"  onClick={() => seleccionarRol(rol, "Editar")} data-widget="pushmenu" href="#" role="button"><i class="fas fa-edit"></i></a>
                <a className="nav-link"  onClick={() => seleccionarRol(rol, "Eliminar")} data-widget="pushmenu" href="#" role="button"><i class="fas fa-trash"></i></a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal isOpen={modalInsertar}>
        <ModalHeader>Insertar Rol</ModalHeader>
        <ModalBody>
          <div className='form-group'>

            <label>Nombre: </label><br />
            <input type="text" className='form-control' name='nombre' onChange={handleChange} required/><br />
          </div>
          {
            errorEnviar && 
            <div className="alert alert-danger">
              {errorEnviar}
            </div>

          }
        </ModalBody>
        <ModalFooter>
          <button disabled={false} className='btn btn-primary' onClick={() => peticionPost()}>Insertar</button>
          <button className='btn btn-danger' onClick={() => abrirCerrarModalInsertar()}>Cancelar</button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalEditar}>
        <ModalHeader>Editar Rol</ModalHeader>
        <ModalBody>
          <div className='form-group'>
            <label>Nombre: </label><br />
            <input type="text" className='form-control' name='nombre' onChange={handleChange} value={rolSeleccionado && rolSeleccionado.nombre} /><br />
          </div>
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-primary' onClick={() => peticionPut()}>Editar</button>
          <button className='btn btn-danger' onClick={() => abrirCerrarModalEditar()}>Cancelar</button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalEliminar}>
        <ModalHeader>Eliminar Rol</ModalHeader>
        <ModalBody>
          ¿Estás seguro que deseas eliminar el Rol {rolSeleccionado.nombre}?
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-primary' onClick={() => peticionDelete()}>Sí</button>
          <button className='btn btn-danger' onClick={() => abrirCerrarModalEliminar()}>No</button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default Rol